// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iYkj","textarea":"styles_textarea__3HIGM"};